document.addEventListener('DOMContentLoaded', function () {
  const { jsPDF } = window.jspdf;

  window.addEventListener("WgWishlistCsvDownload", function(event) {
    console.log("Received wishlist data:", event.detail.data);
    event.preventDefault();
    showCategorySelectionModal(event.detail.data);
  });

  function showCategorySelectionModal(wishlistData) {
    const categories = [...new Set(wishlistData.map(item => item.wishlist_name))];
    
    let modal = document.getElementById('categorySelectionModal');
    if (modal) modal.remove();
    
    modal = document.createElement('div');
    modal.id = 'categorySelectionModal';
    modal.style.cssText = `
      position:fixed;top:0;left:0;width:100%;height:100%;
      background:rgba(0,0,0,0.7);z-index:9999;display:flex;
      align-items:center;justify-content:center;
    `;

    let categoryOptions = categories.map(cat => 
      `<label style="display: flex;padding:10px;cursor:pointer;border:1px solid #ddd;margin:5px 0;border-radius:5px;background:#f9f9f9;transition:background 0.3s;align-items: center;">
        <input type="checkbox" class="category-checkbox" value="${cat}" style="margin-right:10px;">
        ${cat}
      </label>`
    ).join('');

    modal.innerHTML = `
      <div style="position:relative;width:600px;background:#fff;padding:23px;border-radius:0;box-shadow:0 4px 6px rgba(0,0,0,0.1);">
        <h3 style="margin:0 0 20px 0;text-align:center;color:#333;font-size: 25px;font-weight: var(--font-weight-semibold);text-transform: var(--product-title-text-transform);">Select Categories</h3>
        <div style="max-height:300px;overflow-y:auto;">
          <label style="display:block;padding:10px;cursor:pointer;border:2px solid #4CAF50;margin:5px 0;border-radius:5px;background:#e8f5e9;font-weight:bold;transition:background 0.3s;">
            <input type="checkbox" id="selectAllCheckbox" checked style="margin-right:10px;">
            All Products
          </label>
          ${categoryOptions}
        </div>
        <div id="selectedInfo" style="margin-top:15px;padding:10px;background:#f0f0f0;border-radius:5px;min-height:40px;font-size:14px;color:#555;">
          <strong>Selected:</strong> All Products
        </div>
        <div style="margin-top:20px;display:flex;justify-content:space-between;">
          <button id="cancelCategoryBtn" style="padding:10px 20px;background: #dc3545;color:white;border:none;cursor:pointer;">Cancel</button>
          <button id="generatePDFBtn" style="padding:10px 20px;background: #e5d848;color: #4b4b4b;border:none;cursor:pointer;">Generate PDF</button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const selectAllCheckbox = document.getElementById('selectAllCheckbox');
    const categoryCheckboxes = document.querySelectorAll('.category-checkbox');
    const selectedInfo = document.getElementById('selectedInfo');

    function updateSelectedInfo() {
      const selected = [];
      if (selectAllCheckbox.checked) {
        selected.push('All Products');
      } else {
        categoryCheckboxes.forEach(cb => {
          if (cb.checked) selected.push(cb.value);
        });
      }

      if (selected.length === 0) {
        selectedInfo.innerHTML = '<strong style="color:#f44336;">Selected:</strong> None (Please select at least one category)';
      } else {
        selectedInfo.innerHTML = `<strong>Selected:</strong> ${selected.join(', ')}`;
      }

      categoryCheckboxes.forEach(cb => {
        const label = cb.parentElement;
        if (cb.checked) {
          label.style.background = '#e3f2fd';
          label.style.borderColor = '#2196F3';
        } else {
          label.style.background = '#f9f9f9';
          label.style.borderColor = '#ddd';
        }
      });

      const allLabel = selectAllCheckbox.parentElement;
      if (selectAllCheckbox.checked) {
        allLabel.style.background = '#e8f5e9';
        allLabel.style.borderColor = '#4CAF50';
      } else {
        allLabel.style.background = '#f9f9f9';
        allLabel.style.borderColor = '#ddd';
      }
    }

    selectAllCheckbox.addEventListener('change', function() {
      if (this.checked) {
        categoryCheckboxes.forEach(cb => cb.checked = false);
      }
      updateSelectedInfo();
    });

    categoryCheckboxes.forEach(cb => {
      cb.addEventListener('change', function() {
        if (this.checked) {
          selectAllCheckbox.checked = false;
        }
        updateSelectedInfo();
      });
    });

    document.getElementById('cancelCategoryBtn').onclick = () => modal.remove();

    document.getElementById('generatePDFBtn').onclick = () => {
      let filteredData = [];
      
      if (selectAllCheckbox.checked) {
        filteredData = wishlistData;
      } else {
        const selectedCategories = Array.from(categoryCheckboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.value);
        
        if (selectedCategories.length === 0) {
          alert('Please select at least one category!');
          return;
        }
        
        filteredData = wishlistData.filter(item => 
          selectedCategories.includes(item.wishlist_name)
        );
      }
      
      modal.remove();
      showLoader();
      generateWishlistPDF(filteredData);
    };

    updateSelectedInfo();
  }

  function showLoader() {
    let loader = document.getElementById('pdfGeneratingLoader');
    if (loader) loader.remove();
    
    loader = document.createElement('div');
    loader.id = 'pdfGeneratingLoader';
    loader.style.cssText = `
      position:fixed;top:0;left:0;width:100%;height:100%;
      background:rgba(0,0,0,0.8);z-index:10000;display:flex;
      align-items:center;justify-content:center;flex-direction:column;
    `;

    loader.innerHTML = `
      <div style="text-align:center;">
        <div style="border:8px solid #f3f3f3;border-top:8px solid #4CAF50;border-radius:50%;width:80px;height:80px;animation:spin 1s linear infinite;margin:0 auto;"></div>
        <h2 style="color:white;margin-top:20px;font-family:Arial,sans-serif;">Generating PDF...</h2>
        <p style="color:#ddd;font-family:Arial,sans-serif;">Please wait while we prepare your wishlist</p>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

    document.body.appendChild(loader);
  }

  function hideLoader() {
    const loader = document.getElementById('pdfGeneratingLoader');
    if (loader) loader.remove();
  }

  async function generateWishlistPDF(wishlistData) {
    try {
      if (!wishlistData || wishlistData.length === 0) {
        hideLoader();
        return alert('No wishlist data found');
      }

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 15;
      const contentWidth = pageWidth - (margin * 2);

      const logoUrl = 'https://xhb2s3-st.myshopify.com/cdn/shop/files/imgi_1_logo.png';
      const logoBase64 = await getBase64(logoUrl);
      const img = new Image();
      img.src = logoBase64;
      await img.decode();
      const ratio = img.height / img.width;
      const logoWidth = 40;
      const logoHeight = logoWidth * ratio;

      pdf.addImage(logoBase64, 'PNG', margin, 15, logoWidth, logoHeight);
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.text('3015 MD 32', pageWidth - 40, 20);
      pdf.text('West Friendship, MD 21794', pageWidth - 60, 25);
      pdf.text('Telephone: (410) 910-8309', pageWidth - 60, 30);
      pdf.text('Email: sales@iconicpineapple.com', pageWidth - 70, 35);
      pdf.line(margin, 45, pageWidth - margin, 45);

      let yPosition = 55;

      // ======= UPDATED: Fetch SKU + Size metafield =======
      const items = await Promise.all(
        wishlistData.map(async (item) => {
          let sku = '';
          let dimensions = '';
          
          if (item.product_id || item.handle) {
            try {
              const productInfo = await fetchProductInfo(item.product_id, item.variant_id, item.handle);
              sku = productInfo.sku;
              dimensions = productInfo.dimensions;
            } catch (error) {
              console.warn('Failed to fetch product info:', item.product_id || item.handle, error);
            }
          }

          return {
            img: item.image ? `https:${item.image}` : '',
            title: item.title || '',
            price: item.price ? `$${parseFloat(item.price).toFixed(2)}` : '',
            qty: item.quantity || '1',
            handle: item.handle || '',
            sku: sku || 'N/A',
            dimensions: dimensions || '',
            wishlist_name: item.wishlist_name || 'N/A'
          };
        })
      );

      await addItemsToPDF(pdf, items, yPosition, margin, contentWidth, pageHeight);
      showPDFInModal(pdf);
      hideLoader();
    } catch (error) {
      console.error('Error generating PDF:', error);
      hideLoader();
      alert('Error generating PDF. Please try again.');
    }
  }

  // Fetch SKU + dimensions for PDF rows
  async function fetchProductInfo(productId, variantId, handle) {
  try {
    let productUrl;

    if (handle) {
      productUrl = `${window.location.origin}/products/${handle}.json`;
    } else {
      productUrl = `${window.location.origin}/products/${productId}.json`;
    }

    const response = await fetch(productUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const productData = await response.json();

    const sku = extractSKUFromProduct(productData, variantId);
    const dimensions = await fetchDimensionsFromProductPage(handle, productId);

    return {
      sku: sku || '',
      dimensions: dimensions || ''
    };

  } catch (error) {
    console.error('Error fetching product info:', error);
    return { sku: '', dimensions: '' };
  }
}

  async function fetchDimensionsFromProductPage(handle, productId) {
    try {
      let productPageUrl;
      if (handle) {
        productPageUrl = `${window.location.origin}/products/${handle}`;
      } else {
        productPageUrl = `${window.location.origin}/products/${productId}`;
      }

      const response = await fetch(productPageUrl);
      if (!response.ok) return '';

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const strongTags = doc.querySelectorAll('strong');
      for (const strong of strongTags) {
        const label = (strong.textContent || '').trim().toLowerCase();
        if (label === 'dimensions:' || label === 'dimensions') {
          const parentText = (strong.parentElement?.textContent || '').trim();
          const dimensionsValue = parentText.replace(/^\s*dimensions\s*:?\s*/i, '').trim();
          if (dimensionsValue) return dimensionsValue;
        }
      }

      return '';
    } catch (error) {
      console.warn('Failed to fetch dimensions from product page:', handle || productId, error);
      return '';
    }
  }

  function extractSKUFromProduct(productData, variantId) {
    if (variantId && productData.product && productData.product.variants) {
      const variant = productData.product.variants.find(v => v.id.toString() === variantId.toString());
      if (variant && variant.sku) return variant.sku;
    }
    
    if (productData.product && productData.product.variants && productData.product.variants.length > 0) {
      const firstVariant = productData.product.variants[0];
      if (firstVariant && firstVariant.sku) return firstVariant.sku;
    }
    
    return '';
  }

  async function addItemsToPDF(pdf, items, startY, margin, contentWidth, pageHeight) {
    let y = startY;
    const rowHeight = 35; // Slightly taller to fit Size line
    const imageMaxHeight = 24;
    const imageMaxWidth = 24;
    let rowsOnPage = 0;
    let isFirstPage = true;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const maxRowsPerPage = isFirstPage ? 6 : 7;

      if (rowsOnPage === maxRowsPerPage) {
        pdf.addPage();
        y = 20;
        rowsOnPage = 0;
        isFirstPage = false;
      }

      pdf.setFillColor(244, 244, 244);
      pdf.rect(margin, y, contentWidth, rowHeight, 'F');
      pdf.setDrawColor(150, 150, 150);
      pdf.rect(margin, y, contentWidth, rowHeight);

      const centerY = y + (rowHeight / 2);
      const imgX = margin + 2;

      if (item.img) {
        try {
          const base64Img = await getBase64(item.img);
          const img = new Image();
          img.src = base64Img;
          await img.decode();

          const naturalW = img.width;
          const naturalH = img.height;
          const scale = Math.min(imageMaxWidth / naturalW, imageMaxHeight / naturalH);
          const displayW = naturalW * scale;
          const displayH = naturalH * scale;
          const imgY = centerY - (displayH / 2);
          const centeredX = imgX + (imageMaxWidth - displayW) / 2;

          pdf.addImage(base64Img, 'JPEG', centeredX, imgY, displayW, displayH);
        } catch (error) {
          console.warn('Failed to load image:', item.img, error);
        }
      }

      const textX = imgX + imageMaxWidth + 5;

      // Product title
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 120);
      pdf.setFont('helvetica', 'bold');
      if (item.title) pdf.text(item.title, textX, centerY - 10, { maxWidth: contentWidth - (imageMaxWidth + 50) });

      // SKU, Dimensions (if present), Quantity
      pdf.setFontSize(9);
      pdf.setTextColor(0, 0, 0);
      pdf.setFont('helvetica', 'normal');
      pdf.text(`SKU: ${item.sku}`, textX, centerY - 2, { maxWidth: contentWidth - (imageMaxWidth + 50) });
      let infoY = centerY + 4;
      if (item.dimensions && item.dimensions.trim()) {
        pdf.text(`Dimensions: ${item.dimensions}`, textX, infoY, { maxWidth: contentWidth - (imageMaxWidth + 50) });
        infoY += 6;
      }
      pdf.text(`Quantity: ${item.qty}`, textX, infoY);

      // Price (right-aligned)
      if (item.price) {
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'bold');
        pdf.text(item.price, margin + contentWidth - 10, centerY, { align: 'right', baseline: 'middle' });
      }

      y += rowHeight + 5;
      rowsOnPage++;
    }

    return y;
  }

  function showPDFInModal(pdf) {
    const pdfBlob = pdf.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    let modal = document.getElementById('pdfPreviewModal');
    if (modal) {
      URL.revokeObjectURL(modal.dataset.blobUrl);
      modal.remove();
    }
    
    modal = document.createElement('div');
    modal.id = 'pdfPreviewModal';
    modal.dataset.blobUrl = pdfUrl;
    modal.style.cssText = `
      position:fixed;top:0;left:0;width:100%;height:100%;
      background:rgba(0,0,0,0.7);z-index:9999;display:flex;
      align-items:center;justify-content:center;
    `;

    modal.innerHTML = `
      <div style="position:relative;width:80%;height:90%;background:#fff;overflow:hidden;border-radius:8px;display:flex;flex-direction:column;">
        <div style="padding:10px;display:flex;justify-content:space-between;align-items:center;background:#f4f4f4;">
          <h3 style="margin:0;">PDF Preview</h3>
          <div>
            <button id="downloadPDFBtn" style="margin-right:10px;padding:8px 16px;background:#80808066;color:000;border:none;border-radius:5px;cursor:pointer;font-weight:bold;">Download PDF</button>
            <button id="closePDFModal" style="padding:8px 16px;background:#80808066;color:#000;border:none;border-radius:5px;cursor:pointer;font-weight:bold;">Close</button>
          </div>
        </div>
        <iframe id="pdfFrame" style="flex:1;border:none;width:100%;"></iframe>
      </div>
    `;

    document.body.appendChild(modal);

    document.getElementById('closePDFModal').onclick = () => {
      URL.revokeObjectURL(pdfUrl);
      modal.remove();
    };

    document.getElementById('downloadPDFBtn').onclick = () => {
      pdf.save('wishlist.pdf');
    };

    const iframe = document.getElementById('pdfFrame');
    iframe.src = pdfUrl;
  }

  async function getBase64(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
});